<template>
  <v-main class="d-flex flex-column align-center">
    <div class="auth-container">
      <v-img v-if="!$vuetify.display.xs" :src="logo" width="172" class="d-block mr-auto ml-auto" />
      <v-img v-else :src="logoInline" width="136" class="d-block mr-auto ml-auto flex-0-1" />
      <div class="auth-content">
        <slot />
      </div>
    </div>
  </v-main>
</template>

<script lang="ts" setup>
import logoInline from '@/assets/img/logo-inline.svg';
import logo from '@/assets/img/logo.svg';
</script>

<style lang="scss" scoped>
.auth {
  &-container {
    width: 100%;
    max-width: 520px;
    margin-top: 80px;
    padding-bottom: 20px;
  }

  &-content {
    margin-top: 40px;
    padding: 40px;

    background-color: $main-bg-color;
    border-radius: $border-radius-xl;
  }

  @include md-and-down {
    &-container {
      margin-top: 40px;
    }
  }

  @include xs {
    &-container {
      display: flex;
      flex-direction: column;

      min-height: 100%;
      margin-top: 0;
      padding-top: 16px;
      padding-bottom: 0;
    }

    &-content {
      display: flex;
      flex-grow: 1;
      flex-direction: column;

      margin-top: 16px;
      padding: 16px;

      border-radius: $border-radius-l $border-radius-l 0 0;
    }
  }
}
</style>
